<template>
  <img :src="src" v-bind="$attrs" class="block" />
</template>

<script setup lang="ts">
defineProps({
  src: {
    type: String,
    required: true,
  },
});
</script>
